import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import CuratedSelectionIcon from "@faire/retailer-visitor-shared/icons/Collections.svg";
import FreeReturnsIcon from "@faire/retailer-visitor-shared/icons/FreeReturn.svg";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Calendar60 } from "@faire/web--source/slate/icons/CalendarDays";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackProductInfoValuePropsView } from "@faire/web-api--source/events/productInfo/view/valueProps";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
var ProductPerksCardBase = function() {
    var ref = useDoActionWhenVisible(trackProductInfoValuePropsView);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "WQRCRM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Stock your store with Faire"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(Perks, {})
        ]
    });
};
var PerksBase = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var perks = [
        {
            id: 1,
            icon: /*#__PURE__*/ _jsx("img", {
                src: CuratedSelectionIcon,
                alt: strictLocalize({
                    id: "hdSfCF",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Curated selection of items"
                        }
                    ]
                }),
                style: {
                    height: "20px",
                    width: "20px"
                }
            }),
            text: strictLocalize({
                id: "PgaFCK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Find unique items from independent brands"
                    }
                ]
            })
        },
        {
            id: 2,
            icon: /*#__PURE__*/ _jsx(Calendar60, {
                height: "20px",
                width: "20px",
                titleAccess: strictLocalize({
                    id: "ag3Ad/",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Calendar with 60 days"
                        }
                    ]
                })
            }),
            text: strictLocalize({
                id: "2bp6+k",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Buy now, pay later with 60-day payment terms"
                    }
                ]
            })
        },
        {
            id: 3,
            icon: /*#__PURE__*/ _jsx("img", {
                src: FreeReturnsIcon,
                alt: strictLocalize({
                    id: "0G5T86",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Free returns box"
                        }
                    ]
                }),
                style: {
                    height: "20px",
                    width: "20px"
                }
            }),
            text: strictLocalize({
                id: "OTFoIY",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Free returns for risk-free buying"
                    }
                ]
            })
        }
    ];
    return /*#__PURE__*/ _jsx(Column, {
        gap: "3x",
        children: perks.map(function(perk) {
            return /*#__PURE__*/ _jsxs(PerkRow, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        children: perk.icon
                    }),
                    /*#__PURE__*/ _jsx(Column, {
                        flex: 1,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            children: perk.text
                        })
                    })
                ]
            }, perk.id);
        })
    });
};
var Perks = observer(PerksBase);
export var ProductPerksCard = observer(ProductPerksCardBase);
var Wrapper = styled(Column).attrs({
    justify: "flex-start",
    align: "center"
}).withConfig({
    componentId: "sc-7e82f559-0"
})([
    "width:100%;background-color:",
    ";padding:",
    ";"
], Core.surface.muted, getSpacing("4x"));
var PerkRow = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-7e82f559-1"
})([
    "width:100%;"
]);
var Icon = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-7e82f559-2"
})([
    "width:40px;height:40px;border-radius:50%;background-color:",
    ";margin-right:20px;"
], Core.surface.inverse);
